// @flow strict

import * as React from 'react';
import cx from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import { Link } from '../../internal/Button';
import ResponsiveImage from '../../internal/ResponsiveImage';
import ExpanderAnimation from '../../internal/ExpanderAnimation';

type PanelType = {|
  title: string,
  icon: string,
  links: Array<{|
    name: string,
    href: string,
  |}>,
|};

type PropTypes = {|
  title: string,
  intro: string,
  panels: Array<PanelType>,
|};

const Panel = (props: { ...PanelType }) => {
  const [open, toggle] = React.useState(false);
  const onClick = () => {
    toggle(!open);
  };

  return (
    <div className={cx(styles.panel, open && styles.isOpen)}>
      <button className={styles.titleContainer} onClick={onClick}>
        <h2>
          <ResponsiveImage
            className={styles.image}
            src={props.icon}
            alt=""
            defaultSize={{ width: 24, height: 24 }}
          />
          {props.title}
        </h2>
      </button>
      <ExpanderAnimation open={open}>
        <ul className={styles.links}>
          {props.links.map((link, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li className={styles.linkWrapper} key={index}>
              <Link href={link.href} className={styles.link} variant="SubtleLink">
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </ExpanderAnimation>
    </div>
  );
};

export default (props: PropTypes) => {
  return (
    <PageContentBlock title={props.title} intro={props.intro} layout="Thin">
      <div>
        {props.panels.map((panel, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Panel {...panel} key={index} />
        ))}
      </div>
    </PageContentBlock>
  );
};
